export const storeMailOps = {
    updateMailModelEntriesFromDb: params => {
        console.log('default implement updateMailModelEntriesFromDb', params);
    },
    updateMailEntities: list => {
        console.log('default implement updateMailEntities', list);
    },
    updateMailEntity: ev => {
        console.log('default implement updateMailEntity', ev);
    },
    updateMailTag: payload => {
        console.log('default implement updateMailTag', payload);
    },
    resetMailWithDraft: payload => {
        console.log('default implement resetMailWithDraft', payload);
    },
    updateAiAssistVisiable: () => {
        console.log('default implement updateAiAssistVisiable');
    },
    updateAiAssistVisiable_sd: payload => {
        console.log('default implement updateAiAssistVisiable_sd', payload);
    },
    readMailFromAI: payload => {
        console.log('default implement readMailFromAI', payload);
    },
    openFileFromAI: payload => {
        console.log('default implement openFileFromAI', payload);
    },
    extractMailFromAI: payload => {
        console.log('default implement extractMailFromAI', payload);
    },
    removeMailFromAI: function (params) {
        console.log('default implement removeMailFromAI', params);
        throw new Error('Function removeMailFromAI not implemented.');
    },
    setMailReadFromAI: function (params) {
        console.log('default implement setMailReadFromAI', params);
        throw new Error('Function setMailReadFromAI not implemented.');
    },
    setMailFlagFromAI: function (params) {
        console.log('default implement setMailFlagFromAI', params);
        throw new Error('Function setMailFlagFromAI not implemented.');
    },
};
